import { gql, useMutation } from '@apollo/client';
const REPORT_TIMING_MUTATION = gql `
    mutation ReportSearchTiming($duration: Int!, $timing: TimingType!, $tripStateId: ID!) {
        recordTiming(duration: $duration, timing: $timing, tripStateId: $tripStateId)
    }
`;
export function useRecordTiming() {
    return useMutation(REPORT_TIMING_MUTATION);
}
